import React, { FC } from 'react'

import { Button as MuiButton } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import { ButtonProps } from './Button.types'

export const Button: FC<ButtonProps> = ({ testId = 'Button', children, ...props }) => (
  <MuiButton {...props} data-testid={testId}>
    {children}
  </MuiButton>
)

export const PillButton: FC<ButtonProps> = ({ testId = 'PillButton', ...props }) => {
  const classes = useStyles(props)
  const { children, className, type, onClick, loading } = props

  return (
    <MuiButton
      className={`${classes.pill} ${className || ''}`}
      type={type}
      onClick={onClick}
      disabled={loading}
      data-testid={testId}
    >
      {children}
      {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : null}
    </MuiButton>
  )
}

const useStyles = makeStyles(() =>
  createStyles({
    pill: {
      borderRadius: '24px',
      borderColor: (props: ButtonProps) => props.borderColor || 'black',
      color: (props: ButtonProps) => (props.solid ? 'white' : props.textColor || 'black'),
      backgroundColor: (props: ButtonProps) =>
        props.solid ? '#000' : props.backgroundColor ? props.backgroundColor : '#fff',
      fontWeight: 'bold',
      borderWidth: '1px',
      borderStyle: 'solid',
      position: 'relative',
      '&:disabled': {
        borderRadius: '24px',
        borderColor: (props: ButtonProps) => props.borderColor || 'rgba(0,0,0,0.5)',
        color: (props: ButtonProps) => (props.solid ? 'rgba(255, 255, 255, 0.5)' : props.textColor || 'rgba(0,0,0,0.5)')
      },
      '&:hover': {
        backgroundColor: (props: ButtonProps) => (props.solid ? 'rgba(0,0,0,0.8)' : 'initial')
      }
    },
    buttonProgress: {
      color: 'rgba(0,0,0,0.5)',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    }
  })
)
